function Footer() {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <p>© 2026 Chinatao. Все права защищены.</p>

        <a
          className="footer-credit"
          href="#top"
          aria-label="Path of Vision"
        >
          <span>created by</span>
          <strong>Path of Vision</strong>
        </a>
      </div>
    </footer>
  );
}

export default Footer;